import { Button, Stack } from '@mui/material'
import { Link } from 'react-router-dom'
import { ChangeLanguage } from './ChangeLanguage'
import { useTranslation } from 'react-i18next'
export const Main = () => {
  const { t } = useTranslation("header");
  return (
    <Stack sx={{
      justifyContent: "end",
      alignItems: "center",
      width: "100%",
      px: { xs: 1.5, md: 4 },
      py: 0.75,
      position: "relative",
      zIndex: 300,
      flexDirection: "row",
      backgroundColor: "secondary.dark",
      borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
      display: { xs: "none", md: "flex" },
    }}>
      <Button sx={{ color: "text.main", display: "flex", alignItems: "center", gap: 1, fontSize: ["11px", "13px"], opacity: 0.86, px: 1.5 }} component={Link} to={`/faq`}>
        {t("faq")}
      </Button>
      <Button sx={{ color: "text.main", display: "flex", alignItems: "center", gap: 1, fontSize: ["11px", "13px"], opacity: 0.86, px: 1.5 }} component={Link} to={`/terms-of-service`}>
        {t("Terms of Service")}
      </Button>
      <ChangeLanguage />
    </Stack>
  )
}
